import { useCallback } from 'react';

import { useConfigSlice, useCoreDispatch } from '@pp/core';

import { useMwGameStateSlice } from '../slices/mwGame/selectors';
import { fetchRecentResultsPercentageAction } from '../apiActions/fetchRecentResultsPercentageAction';

export const useRecentResultPercentageFetcher = (): (() => void) => {
  const dispatch = useCoreDispatch();
  const recentResultsCount = useMwGameStateSlice.recentResultsCount();
  const JSESSIONID = useConfigSlice.JSESSIONID();
  const tableId = useConfigSlice.tableId();
  const gsAddress = useConfigSlice.gsAddress();
  const NO_OF_GAMES = 500;

  return useCallback(() => {
    if (JSESSIONID && gsAddress && tableId) {
      dispatch(
        fetchRecentResultsPercentageAction({
          JSESSIONID,
          tableId,
          noOfGames: NO_OF_GAMES,
          ck: Date.now().toString(),
          url: `${gsAddress}/api/ui/stats`,
        })
      );
    }
  }, [dispatch, recentResultsCount, JSESSIONID, gsAddress, tableId]);
};
